
  import { defineComponent } from 'vue';
  import { AllAttributesType, allAttrsEnum, MetricsType } from '@/services/api/resources/analytics-builder/constants';
  import { useAttributes, useMetrics } from '@/ui/concerns/analytics/widget';
  import { t } from '@/ui/i18n/i18n';

  interface WidgetTitleProps {
    metric: MetricsType;
    attribute: AllAttributesType;
  }

  export default defineComponent<WidgetTitleProps>({
    props: ['metric', 'attribute'],
    setup(props) {
      const { findMetricLabel } = useMetrics();
      const { allAttributeLabels } = useAttributes();

      const by = props.attribute === allAttrsEnum.total ? ' ' : ` ${t('analytics.by')} `;
      const title = `${allAttributeLabels[props.attribute]}${by}${findMetricLabel(props.metric)}`;

      return {
        title,
      };
    },
  });
